/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:03:35
 * @FilePath: /dbrank_b/src/routes/visualChart/P3/index.js
 * @Description: p3
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title3 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';

class P3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  render() {
    const { chartTitle, chartList, chartColorList } = this.state;
    return (
      <Stage>
        <Title3 pageNumber="06">参展商品牌头部内容引爆力前10名</Title3>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.des}>西门子传播效果最高的TOP10内容之和居本届进博会所有参展商品牌之首。第2-10名为欧莱雅、蒂森克虏伯、精工爱普生、勃林格殷格翰、霍尼韦尔、迪卡侬、松下、特斯拉、梅赛德斯奔驰。</div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <TooltipDrawer
                style={{ width: '100%', height: '100%' }}
                formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <Chart isShow options={setChart({
                  title: chartTitle,
                  list: chartList,
                  color: chartColorList,
                })} />
              </TooltipDrawer>
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P3);



// WEBPACK FOOTER //
// src/routes/visualChart/P3/index.js